<template>
	<main id="form">
		<form autocomplete="off" v-on:submit.self.stop.prevent="validateForm()">
			<h2>{{this.properties && getLabel(this.properties.title)}}</h2>
			<ul v-if="properties.fields">
				<li>
					<pools_checkbox_input v-on:validateField="validateField" v-bind:params="getParams('pools_checkbox')" v-bind:oldValue="oldValue[fieldName]" v-bind:lang="lang" v-bind:templateIndex="templateIndex"></pools_checkbox_input>
				</li>
				<li v-if="!this.availableResults.choices.length">
					Aucun souhait ne correspond aux critères que vous avez sélectionnés auparavant dans cette catégorie.
				</li>
			</ul>
			<button v-bind:class="isActive ? 'selected' : ''" type="submit">{{getLabel(fields.next)}}</button>
		</form>
	</main>
</template>

<script>
//Input components
import pools_checkbox_input from '@/components/candidate_forms/pools_checkbox_input.vue';

import lib from '@/libs/main.js';
import ey_spec from '@/libs/ey_spec.js';
import componentTools from '@/libs/componentTools.js';

function checkForm(scope){
	if(!scope.properties || !scope.properties.fields || !Array.isArray(scope.properties.fields)) return true;
	return scope.properties.fields.every(field => {
		if(!field.params.compulsory) return true;
		return scope.answer[field.params.name];
	});
}
export default {
	name: 'candidate_wishes3Tpl',
	data() {
		return {
			availableResults : [],
			answer : {},
			oldValue : {},
			isActive : true,
			fields : {
				next : {
					fr : 'Valider',
					en : 'Next'
				}
			}
		}
	},
	props : ['currentSession', 'properties', 'lang', 'templateIndex'],
	components : {
		pools_checkbox_input
	},
	methods : {
		validateForm : function() {
			if(!checkForm(this)) return;
			var t = this;
			let out = {};
			this.properties.fields.forEach( field => {
				if(field.params.name == "candidate_wishes3" && this.answer[field.params.name]){
					this.answer[field.params.name].forEach(function(k,i){
						out[t.availableResults.choices[k].label] = true;
					});
				}
			});
			delete this.currentSession.stepsResults.candidate_wishes4Tpl_8
			delete this.currentSession.stepsResults.candidate_wishesTpl_9;
			this.$emit('validateStep', this.$options.name, out);
		},
		validateField : function(name, value) {
			this.answer[name] = value;
			this.isActive = checkForm(this);
		},
		scrollToThisInput : function(event) {
			return lib.scrollToElem(event.target);
		},
		getParams : function(type){
			var contract;
			switch(this.currentSession.stepsResults.availabilityTpl_1.contractType){
				case "0" : contract = "Césure"; break;
				case "1" : contract = "Césure"; break;
				case "2" : contract = "Alternance"; break;
				case "3" : contract = "TFE"; break;
				case "4" : contract = "CDI"; break;
			}
			var schoolStr = this.currentSession.stepsResults.academic_careerTpl_2.schoolStr;
			var featured = [];
			var choices = [];
			Object.keys(ey_spec[schoolStr]).forEach(function(key){
				if(ey_spec[schoolStr][key][contract] == 'O') choices.push(key);
				if(ey_spec[schoolStr][key][contract] == 'OXXX') featured.push(key);
			});
			var defaultChoices = this.properties && this.properties.fields && this.properties.fields.find(x => x.type == type).params;
			defaultChoices = JSON.parse(JSON.stringify(defaultChoices));
			var list = [];
			defaultChoices.choices.forEach(function(choice,i){
				if(featured.indexOf(choice.label) != -1) list.unshift(defaultChoices.choices[i]);
				else if(choices.indexOf(choice.label) != -1) list.push(defaultChoices.choices[i])
			});
			defaultChoices.choices = list;
			// if(!list.length) list.push({"label":"JOK","value":"31","meta":{"_id":"2EKxJGvtttnD62Yxv","value":"JOK"}});
			this.availableResults = defaultChoices;
			return defaultChoices;
		},
		getLabel : componentTools.getLabel
	},
	computed : {
		fieldName : function(index) {
			const params = this.getParams('pools_checkbox');
			return params && params.name;
		},
	},
	watch : {
		templateIndex : {
			handler : function(val, oldval){
				let scope = this;
				let tplRes = scope.currentSession && scope.currentSession.stepsResults && scope.currentSession.stepsResults[scope.$options.name + '_' + scope.templateIndex];
				if(!tplRes){
					scope.oldValue = {};
					scope.answer = {};
				} else {
					scope.oldValue = JSON.parse(JSON.stringify(tplRes));
					scope.answer = JSON.parse(JSON.stringify(tplRes));
				}
			}
		},
	},
	created : function(){
		componentTools.created.call(this);
		const oldRes = this.currentSession.stepsResults[this.$options.name + '_' + this.templateIndex];
		if(!this.currentSession.stepsResults.secteurTpl_3.candidate_wishes3){
			if(this.currentSession.stepsResults.candidate_wishes3Tpl_7) this.currentSession.goToPreviouslPage();
			else this.validateForm()
		}
		// can't save properly due to _id choice translations
		// if(oldRes) this.oldValue = {candidate_wishes3 : JSON.parse(JSON.stringify(oldRes)).candidate_wishes3.map(e=>e.value)};

	}
};
</script>

<style lang="less">
@import '../../assets/less/conf.import.less';
#form ul{
	li{
		position: relative;
		margin-top: 3%;
		margin-bottom: 3%;
		label{
			position: absolute;
			left: 0;
			margin-top: 2%;
			max-width: 40%;
			text-align: left;
		}
		input{
			&[type="date"]{
				width: 40%;
				margin-left: 60%;
			}
			&[type="checkbox"], &[type="radio"]{
				display: inline-block;
			}
			&[type="text"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="email"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="number"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="tel"]{
				width: 50%;
				margin-left: 50%;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ey/candidate_wishes3.vue